import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
} from '@angular/core';
import { fromEvent, merge, Observable, Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import { TranslationKeyMap } from './vimeo.i18n';
import { Playlist, PlaylistItem } from './vimeo.model';

function bindResize(el: HTMLElement, src: HTMLElement): Observable<any> {
    let didReq;
    return merge(fromEvent(el, 'trigger'), fromEvent(window, 'resize')).pipe(
        filter(() => !didReq),
        tap(() => {
            didReq = true;
            window.requestAnimationFrame(() => {
                didReq = false;
                el.style.maxHeight = `${src.getBoundingClientRect().height}px`;
            });
        }),
    );
}

function unbindResize(sub: Subscription): void {
    if (sub) {
        sub.unsubscribe();
    }
}

@Component({
    selector: 'cmps-vimeo-playlist',
    templateUrl: './playlist.vimeo.component.html',
})
export class PlaylistVimeoComponent
    implements OnChanges, AfterViewInit, OnDestroy
{
    @Input() isPlayerQueue: boolean;
    @Input() list: Playlist;
    @Input() currentItem: PlaylistItem;

    i18n = TranslationKeyMap;
    /* internal */
    isExpanded: boolean;
    private _resizeSub: Subscription;

    constructor(private readonly _el: ElementRef) {}

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line no-prototype-builtins, @typescript-eslint/dot-notation
        if (
            // eslint-disable-next-line no-prototype-builtins
            changes.hasOwnProperty('isPlayerQueue') &&
            // eslint-disable-next-line @typescript-eslint/dot-notation
            !changes['isPlayerQueue'].isFirstChange()
        ) {
            this._runBindResize();
        }
    }

    ngAfterViewInit(): void {
        this._runBindResize();
    }

    ngOnDestroy(): void {
        unbindResize(this._resizeSub);
    }

    onToggleList($event: MouseEvent | KeyboardEvent): void {
        this.isExpanded = !this.isExpanded;
    }

    onItemDescClick($event: MouseEvent | KeyboardEvent): void {
        const el = ($event.target as HTMLElement).parentElement;
        if (el.classList.contains('full-description')) {
            el.classList.remove('full-description');
        } else {
            el.classList.add('full-description');
        }
    }

    private _runBindResize(): void {
        unbindResize(this._resizeSub);
        if (this.isPlayerQueue) {
            const el = (this._el.nativeElement as HTMLElement)
                .childNodes[0] as HTMLElement;

            this._resizeSub = bindResize(
                el,
                document.querySelector('#cmpsVimeoPlayerContainer'),
            ).subscribe(null, () => null);

            const e = document.createEvent('Event');
            e.initEvent('trigger', true, false);
            el.dispatchEvent(e);
        }
    }
}
